module.exports = __webpack_public_path__ + "img/kitkitphoto8.8d224915.jpg";